
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'list-group',
    styleUrls: ['./list-group.component.scss'],
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
        <div class="list-group {{districtClass}}" [hidden]="!showList">
          @if (optionalText) {
            <button
              type="button"
              class="list-group-item"
              (mousedown)="onSelect(null)"
            >{{optionalText}}</button>
          }
        
          @for (search of searches; track search; let index = $index) {
            @if (optionGroupCount > 1 && optionGroupHeader(search, searches, index)) {
              <div class="optionGroupHeader pt-5 p-2">
                {{optionGroupHeader(search, searches, index)}}
              </div>
            }
            <button
              type="button"
              class="list-group-item"
              [class.selected]="defaultValue && optionsText(search) === optionsText(defaultValue)"
              (mousedown)="onSelect(search)"
            >{{optionsText(search)}}</button>
          }
        </div>
        `
})
export class ListGroupComponent<T> {
	@Input() optionalText?: string;
	@Input() districtClass?: string;
	@Input() optionsText: (t: T | null) => string;
	@Input() optionGroupHeader: (element: any, elements: Array<any>, index: number | string) => void
	@Input() optionGroupCount: number;
	@Input() defaultValue?: T | null;
	@Input() stayOpen = false;
	@Input() showList = this.stayOpen;
	@Input() searches: Array<T | null> = [];
	@Output() listClicked = new EventEmitter<T | null>();

	onSelect(elem: T | null) {
		this.listClicked.emit(elem);
	}


}
